// src/components/configurator.js

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AreaDimensionsForm from "./areadimensionsform";
import OptionsForm from "./optionsform";
import PriceDisplay from "./pricedisplay";
import "../App.css";

const Configurator = () => {
  const { id } = useParams();
  const [selectedTile, setSelectedTile] = useState(null);
  const [area, setArea] = useState({ length: "", width: "" });
  const [options, setOptions] = useState({
    installation: null,
    transport: null,
  });
  const [showOptionsForm, setShowOptionsForm] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    async function fetchTile() {
      try {
        const res = await fetch(
          "https://d3ejxze7429gw1.cloudfront.net/products"
        );
        const data = await res.json();
        const tile = data.find((t) => t.id === id);
        if (tile) {
          setSelectedTile({
            id: tile.id,
            name: tile.title,
            price: tile.price,
            size: tile.specifications?.size || "N/A",
            category: tile.category,
            image: tile.imageUrl,
          });
        }
      } catch (err) {
        console.error("Failed to fetch tile:", err);
      }
    }

    fetchTile();
  }, [id]);

  const handleAreaSubmit = (areaData) => {
    setArea(areaData);
    setShowOptionsForm(true);
  };

  const handleBack = () => {
    window.history.back();
  };

  const handleCalculatePrice = (price) => {
    setTotalPrice(price);
  };

  if (!selectedTile) return <p>Loading tile...</p>;

  return (
    <div className="App">
      <div className="">
        <h1
          className="pt-40"
          style={{ wordBreak: "break-word", fontSize: "2rem" }}
        >
          Configure: {selectedTile.name}
        </h1>
        <img
          src={`https://d3ejxze7429gw1.cloudfront.net${selectedTile.image}`}
          alt={selectedTile.name}
          className="flex justify-center"
          style={{ width: "250px", marginBottom: "20px" }}
        />
        {!showOptionsForm ? (
          <AreaDimensionsForm
            selectedTile={selectedTile}
            setArea={handleAreaSubmit}
          />
        ) : (
          <div className="options-price-container">
            <OptionsForm setOptions={setOptions} />
            <PriceDisplay
              selectedTile={selectedTile}
              area={area}
              options={options}
              onCalculatePrice={handleCalculatePrice}
            />
          </div>
        )}
        {showOptionsForm && (
          <button
            onClick={handleBack}
            className="back-button"
            style={{
              backgroundColor: "#64ffda",
              color: "#222",
              padding: "14px 24px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "1.1rem",
              marginTop: "20px",
              boxShadow: "0 4px 8px rgba(100, 255, 218, 0.3)",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            Back to Tiles
          </button>
        )}
      </div>
    </div>
  );
};

export default Configurator;
